module.exports = __webpack_public_path__ + "static/media/4_6.e567aa7c.png";